module.exports = __webpack_public_path__ + "img/katsina-shield.1b55f006.png";